import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaBuilding,
  FaBoxOpen,
  FaQuestionCircle,
  FaChevronRight,
  FaRegUser,
  FaChartBar,
  FaEnvelope,
  FaCog,
  FaSignOutAlt,
} from 'react-icons/fa';
import './vendorsidebar.css';
import logo from '../icons/onlineLogo.png';

const VendorSidebar = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const location = useLocation();

  const handleMenuClick = (menuName) => {
    setExpandedMenu(expandedMenu === menuName ? null : menuName);
  };

  return (
    <div className="global-sources-sidebar">
      {/* Logo Section */}
      <div className="sidebar-logo">
        <img src={logo} alt="Logo" className="logo-image" />
      </div>

      {/* Main Navigation */}
      <nav className="sidebar-nav">
        <ul className="nav-list">
          
          {/* Home */}
          <li className={`nav-item ${location.pathname === '/Vendor/Dashboard' ? 'active' : ''}`}>
            <Link to="/Vendor/Dashboard" className="nav-link">
              <div className="nav-icon-container">
                <FaHome className="nav-icon" />
              </div>
              <span className="nav-label">Home</span>
            </Link>
          </li>

          {/* User Management */}
          <li 
            className={`nav-item ${location.pathname === '/Vendor/UserProfile' ? 'active' : ''} ${expandedMenu === 'user' ? 'expanded' : ''}`}
            onMouseEnter={() => setHoveredMenu('user')}
            onMouseLeave={() => setHoveredMenu(null)}
          >
            <div 
              className="nav-link" 
              onClick={() => handleMenuClick('user')}
            >
              <div className="nav-icon-container">
                <FaRegUser className="nav-icon" />
              </div>
              <span className="nav-label">Account</span>
              <FaChevronRight className={`chevron ${expandedMenu === 'user' ? 'rotated' : ''}`} />
            </div>
            
            {(hoveredMenu === 'user' || expandedMenu === 'user') && (
              <ul className="submenu">
                <li className={`submenu-item ${location.pathname === '/Vendor/UserProfile' ? 'active-sub' : ''}`}>
                  <Link to="/Vendor/UserProfile" className="submenu-link">
                    Profile Settings
                  </Link>
                </li>
                <li className="submenu-item">
                  <Link to="/Vendor/UserProfile" className="submenu-link">
                    Security
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Company Management */}
          <li 
            className={`nav-item ${location.pathname === '/Vendor/BusinessProfile' ? 'active' : ''} ${expandedMenu === 'company' ? 'expanded' : ''}`}
            onMouseEnter={() => setHoveredMenu('company')}
            onMouseLeave={() => setHoveredMenu(null)}
          >
            <div 
              className="nav-link" 
              onClick={() => handleMenuClick('company')}
            >
              <div className="nav-icon-container">
                <FaBuilding className="nav-icon" />
              </div>
              <span className="nav-label">Company</span>
              <FaChevronRight className={`chevron ${expandedMenu === 'company' ? 'rotated' : ''}`} />
            </div>
            
            {(hoveredMenu === 'company' || expandedMenu === 'company') && (
              <ul className="submenu">
                <li className={`submenu-item ${location.pathname === '/Vendor/BusinessProfile' ? 'active-sub' : ''}`}>
                  <Link to="/Vendor/BusinessProfile" className="submenu-link">
                    Company Profile
                  </Link>
                </li>
                <li className="submenu-item">
                  <Link to="/Vendor/BusinessProfile" className="submenu-link">
                    Business Information
                  </Link>
                </li>
                <li className="submenu-item">
                  <Link to="/Vendor" className="submenu-link">
                    Verification
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Product Management */}
          <li 
            className={`nav-item ${location.pathname.includes('/Vendor/AddProductVendor') || location.pathname.includes('/Vendor/AllProduct') ? 'active' : ''} ${expandedMenu === 'product' ? 'expanded' : ''}`}
            onMouseEnter={() => setHoveredMenu('product')}
            onMouseLeave={() => setHoveredMenu(null)}
          >
            <div 
              className="nav-link" 
              onClick={() => handleMenuClick('product')}
            >
              <div className="nav-icon-container">
                <FaBoxOpen className="nav-icon" />
              </div>
              <span className="nav-label">Products</span>
              <FaChevronRight className={`chevron ${expandedMenu === 'product' ? 'rotated' : ''}`} />
            </div>
            
            {(hoveredMenu === 'product' || expandedMenu === 'product') && (
              <ul className="submenu">
                <li className={`submenu-item ${location.pathname === '/Vendor/AddProductVendor' ? 'active-sub' : ''}`}>
                  <Link to="/Vendor/AddProductVendor" className="submenu-link">
                    Add Product
                  </Link>
                </li>
                <li className={`submenu-item ${location.pathname === '/Vendor/AllProduct' ? 'active-sub' : ''}`}>
                  <Link to="/Vendor/AllProduct" className="submenu-link">
                    Manage Products
                  </Link>
                </li>
                <li className="submenu-item">
                  <Link to="/Vendor/AllProduct" className="submenu-link">
                    Product Analytics
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Inquiry Management */}
          <li 
            className={`nav-item ${location.pathname === '/Vendor/AllEnquiryVendor' ? 'active' : ''} ${expandedMenu === 'inquiry' ? 'expanded' : ''}`}
            onMouseEnter={() => setHoveredMenu('inquiry')}
            onMouseLeave={() => setHoveredMenu(null)}
          >
            <div 
              className="nav-link" 
              onClick={() => handleMenuClick('inquiry')}
            >
              <div className="nav-icon-container">
                <FaEnvelope className="nav-icon" />
                <span className="notification-badge">3</span>
              </div>
              <span className="nav-label">Messages</span>
              <FaChevronRight className={`chevron ${expandedMenu === 'inquiry' ? 'rotated' : ''}`} />
            </div>
            
            {(hoveredMenu === 'inquiry' || expandedMenu === 'inquiry') && (
              <ul className="submenu">
                <li className="submenu-item">
                  <Link to="/Vendor/AllEnquiryVendor" className="submenu-link">
                    All Inquiries
                  </Link>
                </li>
                <li className="submenu-item">
                  <Link to="/Vendor/AllEnquiryVendor" className="submenu-link">
                    Unread Messages
                  </Link>
                </li>
                <li className="submenu-item">
                  <Link to="/Vendor/AllEnquiryVendor" className="submenu-link">
                    Sent Messages
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Analytics */}
          <li className={`nav-item ${location.pathname === '/Vendor/Analytics' ? 'active' : ''}`}>
            <Link to="/Vendor/Analytics" className="nav-link">
              <div className="nav-icon-container">
                <FaChartBar className="nav-icon" />
              </div>
              <span className="nav-label">Analytics</span>
            </Link>
          </li>

        </ul>
      </nav>

      {/* Bottom Section */}
      <div className="sidebar-bottom">
        <ul className="nav-list">
          <li className="nav-item">
            <Link to="/Vendor/Settings" className="nav-link">
              <div className="nav-icon-container">
                <FaCog className="nav-icon" />
              </div>
              <span className="nav-label">Settings</span>
            </Link>
          </li>
          
          <li className="nav-item">
            <div className="nav-link" onClick={() => {/* logout logic */}}>
              <div className="nav-icon-container">
                <FaSignOutAlt className="nav-icon" />
              </div>
              <span className="nav-label">Logout</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default VendorSidebar;